export const ALTUS_PROPOSAL_INFO_FORM_ID = 'altus-proposal-info-form';
